import React, { useState } from 'react';
import { companyEmail, emailSendFeedback } from './companyEmail';
export default function EmployeeWelcomeEmail({ company, employee }) {
  const [busy, setBusy] = useState(false), [message, setMessage] = useState(''), [error, setError] = useState(false);
  async function send() {
    if (!window.confirm(`Send a password setup invitation to ${employee.email}? It contains an expiring, single-use link. No password is included.`)) return;
    setBusy(true); setMessage(''); setError(false);
    try { setMessage(emailSendFeedback(await companyEmail(company.id, 'send', { kind:'welcome', employee_id:employee.id }))); }
    catch (error) { setError(true); setMessage(error.message); }
    finally { setBusy(false); }
  }
  return <div style={{ marginTop:14 }}>
    <button type="button" className="btn btn-ghost btn-sm" disabled={busy || !employee.email || employee.is_active === false} onClick={send}>{busy ? 'Sending…' : 'Send password setup invitation'}</button>
    <p style={{ fontSize:11, color:'#64748b', lineHeight:1.7 }}>Emails a secure link to {employee.email || 'the saved employee email'} to set their password. Save email changes first.</p>
    {message && <p role={error ? 'alert' : 'status'} style={{ fontSize:12, lineHeight:1.7, color:error ? '#b45353' : '#187565' }}>{message}</p>}
  </div>;
}
